// src/components/invoice_terms/columns.js
import InvoiceStatusButtons from "./InvoiceStatusButtons";
import SelectFilter from "@inovua/reactdatagrid-community/SelectFilter";

export const columnsDetailed = [
    { name: "ProjectcodeA", header: "Projectcode", flex: 1 },
    { name: "ProjectnaamA", header: "Projectnaam", flex: 1 },
    { name: "Omschrijving", header: "Omschrijving", flex: 2 },
    { name: "Bedrag", header: "Bedrag", flex: 1 },
    {
        name: "Projectleider",
        header: "Projectleider",
        flex: 1,
    },
    { name: "Datumverloop", header: "Datumverloop", flex: 1 },
    {
        name: "Buttons",
        header: "",
        render: ({ data, user }) => (
            <InvoiceStatusButtons
                status={data.status}
                plannedFor={data.Datumverloop}
                project={data.original.project}
                invoice={data.original.invoice}
                isForExcelExport={true}
                user={user}
            />
        ),
        flex: 1,
    },
];

export const columnsDashboard = [
    { name: "ProjectnaamA", header: "Projectnaam", flex: 1 },
    { name: "Projectleider", header: "Projectleider", flex: 1 },
    { name: "Bedrag", header: "Bedrag", flex: 1 },
    { name: "Datumverloop", header: "Datumverloop", flex: 1 },
];
